module.exports = __webpack_public_path__ + "img/4.6d33af7.png";